import React from 'react';
import { Shield, Star, Users, Target } from 'lucide-react';
const values = [{
  icon: Star,
  title: 'Quality Over Quantity',
  description: 'We limit our active client roster to ensure every project receives the dedicated attention and senior-level expertise it deserves.'
}, {
  icon: Users,
  title: 'Client-First Partnership',
  description: 'We view ourselves as an extension of your team, aligning our technical strategies directly with your core business objectives.'
}, {
  icon: Shield,
  title: 'Deep Technical Expertise',
  description: 'From embedded systems to global-scale web applications, our team brings decades of specialized engineering experience.'
}, {
  icon: Target,
  title: 'Long-Term Support',
  description: "Our relationship doesn't end at launch. We provide ongoing project support, maintenance, and iterative enhancements."
}];
export function CoreValues() {
  return <section className="py-20 lg:py-28 bg-background texture-light" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="text-center max-w-3xl mx-auto mb-16 scroll-fade-in-up" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-158">
            Our Core Values
          </h2>
          <p className="text-lg text-muted" data-id="element-159">
            The principles that guide our engineering practices and client
            relationships.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 scroll-fade-in-up" data-id="element-160">
          {values.map((value, index) => {
          const Icon = value.icon;
          return <div key={index} className="card-premium p-8 h-full flex flex-col" data-id="element-161">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center mb-6" data-id="element-162">
                  <Icon className="w-6 h-6 text-accent" data-id="element-163" />
                </div>
                <h3 className="text-xl font-bold text-ink mb-3" data-id="element-164">
                  {value.title}
                </h3>
                <p className="text-muted leading-relaxed flex-grow" data-id="element-165">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}